import * as React from 'react'

import styled from '@theme/styled-components'

import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'
import Theme from '@theme/Theme'

interface Props {
  title: string
  options: CheckboxType[]
  setOptions: (value: CheckboxType[]) => void
}

const Checkboxes = ({ title, options, setOptions }: Props) => {
  const checkboxClicked = (idx: number) => {
    const newOptions = [
      ...options.slice(0, idx),
      { ...options[idx], value: !options[idx].value },
      ...options.slice(idx + 1),
    ]
    setOptions(newOptions)
  }

  return (
    <Container>
      <TitleContainer>
        <Title>{title}</Title>
      </TitleContainer>
      {options.map((a, idx) => (
        <CheckboxContainer key={a.libelle} onClick={() => checkboxClicked(idx)}>
          <Content>
            {a.value ? (
              <MdCheckBox size={25} color={Theme.colors.filterPrimarycolor} />
            ) : (
              <MdCheckBoxOutlineBlank size={25} color={Theme.colors.filterPrimarycolor} />
            )}
          </Content>
          <CheckboxLibelle>{a.libelle}</CheckboxLibelle>
        </CheckboxContainer>
      ))}
    </Container>
  )
}
export default Checkboxes

const Container = styled('div')`
  margin: 10px 20px 0 20px;
`
const TitleContainer = styled('div')``
const Title = styled('div')`
  ${(props) => props.theme.fonts.checkboxesTitle};
`
const Content = styled('div')`
  margin-right: 5px;
  justify-content: center;
  align-items: center;
  display: flex;
`
const CheckboxContainer = styled('div')`
  padding-left: 20px;
  display: flex;
  margin: 5px;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`
const CheckboxLibelle = styled('div')`
  ${(props) => props.theme.fonts.checkboxLibelle};
  width: 90px;
`
